import { WebsiteDropdownGroupTitles, WebsiteDropdownTitles } from '../types'

export const dropdownTitlesLocoKeys: Record<WebsiteDropdownTitles, string> = {
  pageBackgroundColor: 'website_theme_settings.group.page.background_color',
  pageBackgroundPicture: 'website_theme_settings.group.page.background_picture',
  contentBackgroundColor:
    'website_theme_settings.group.content.background_color',
  containerBackgroundColor:
    'website_theme_settings.group.container.background_color',
  popupBackgroundColor: 'website_theme_settings.group.popup.background_color',
  sectionBackgroundColor:
    'website_theme_settings.group.section.background_color',
  headerTextColor: 'website_theme_settings.group.header.text_color',
  headerBackgroundColor: 'website_theme_settings.group.header.background_color',
  headerBackgroundPicture:
    'website_theme_settings.group.header.background_picture',
  footerTextColor: 'website_theme_settings.group.footer.text_color',
  footerBackgroundColor: 'website_theme_settings.group.footer.background_color',
  footerBackgroundPicture:
    'website_theme_settings.group.footer.background_picture',
  headingTextColor: 'website_theme_settings.group.heading.text_color',
  headingBackgroundColor:
    'website_theme_settings.group.heading.background_color',
  paragraphTextColor: 'website_theme_settings.group.paragraph.text_color',
  paragraphBackgroundColor:
    'website_theme_settings.group.paragraph.background_color',
  primaryButtonTextColor:
    'website_theme_settings.group.primary.button_text_color',
  primaryButtonBorderColor:
    'website_theme_settings.group.primary.button_border_color',
  primaryButtonBackgroundColor:
    'website_theme_settings.group.primary.button_background_color',
  primaryHoveredButtonBackgroundColor:
    'website_theme_settings.group.primary.hovered_button_background_color',
  primaryPressedButtonBackgroundColor:
    'website_theme_settings.group.primary.pressed_button_background_color',
  secondaryButtonTextColor:
    'website_theme_settings.group.secondary.button_text_color',
  secondaryButtonBorderColor:
    'website_theme_settings.group.secondary.button_border_color',
  secondaryButtonBackgroundColor:
    'website_theme_settings.group.secondary.button_background_color',
  secondaryHoveredButtonBackgroundColor:
    'website_theme_settings.group.secondary.hovered_button_background_color',
  secondaryPressedButtonBackgroundColor:
    'website_theme_settings.group.secondary.pressed_button_background_color',
  ghostButtonTextColor: 'website_theme_settings.group.ghost.button_text_color',
  ghostButtonBorderColor:
    'website_theme_settings.group.ghost.button_border_color',
  ghostHoveredButtonBackgroundColor:
    'website_theme_settings.group.ghost.hovered_button_background_color',
  ghostPressedButtonBackgroundColor:
    'website_theme_settings.group.ghost.pressed_button_background_color',
  linkTextColor: 'website_theme_settings.group.link.text_color',
  linkHoveredBackgroundColor:
    'website_theme_settings.group.link.hovered_button_background_color',
  linkPressedBackgroundColor:
    'website_theme_settings.group.link.pressed_button_background_color',
  formFieldBackgroundColor:
    'website_theme_settings.group.form_field.background_color',
  formFieldTextColor: 'website_theme_settings.group.form_field.text_color',
  formFieldBorderColor: 'website_theme_settings.group.form_field.border_color',
  dividersColor: 'website_theme_settings.group.dividers.color',
} as const

export const dropdownGroupTitlesLocoKeys: Record<
  WebsiteDropdownGroupTitles,
  string
> = {
  background: 'website_theme_settings.group_title.background',
  headerAndFooter: 'website_theme_settings.group_title.header_and_footer',
  text: 'website_theme_settings.group_title.text',
  buttons: 'website_theme_settings.group_title.buttons',
  links: 'website_theme_settings.group_title.links',
  formFields: 'website_theme_settings.group_title.form_fields',
  miscellaneous: 'website_theme_settings.group_title.miscellaneous',
} as const

export const unusedDropdownTitlesKeys = ['sectionBackgroundColor']
